/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBatteryVerticalOff = createReactComponent("outline", "battery-vertical-off", "IconBatteryVerticalOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M17 13v-6a2 2 0 0 0 -2 -2h-.5a.5 .5 0 0 1 -.5 -.5a.5 .5 0 0 0 -.5 -.5h-3a.5 .5 0 0 0 -.5 .5a.5 .5 0 0 1 -.5 .5h-.5m-2 2v11a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-1", "key": "svg-1" }]]);

export { IconBatteryVerticalOff as default };
//# sourceMappingURL=IconBatteryVerticalOff.mjs.map
